import Dialog from "../../atoms/dialog";
import RestoreBlueprint from "../../molecules/blueprint/RestoreBlueprint"

export default function RestoreBlueprintAlert({ onClose, id, onCompletion }) {
    return (
        <Dialog
            container_id="restore_backup_modal"
            title={"Backup/Restore"}
            handleClose={() => onClose(false)}
            open={true}
            paperProps={{ style: { width: 1700, maxWidth: 1700 } }}
        >
            <RestoreBlueprint onClose={onClose} id={id} onCompletion={onCompletion} />
        </Dialog>
    )
}